<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="voltar" :disabled="submitting">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Lançando Frequências
        </h1>
      </v-col>
    </v-row>

    <v-row v-if="loading">
      <v-col class="text-center pa-12">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        <p class="mt-4">Carregando dados das aulas e alunos...</p>
      </v-col>
    </v-row>

    <div v-else-if="aulas.length">
      <v-row>
        <v-col cols="12" v-if="aulas[0]">
          <v-card color="green lighten-1" class="mb-5" outlined>
            <v-card-title>Professor: {{ aulas[0].professor?.nome }}</v-card-title>
            <v-card-subtitle class="font-weight-medium">
              <div>Turma: {{ aulas[0].turma?.descricao }}</div>
              <div>Componente Curricular: {{ aulas[0].disciplina?.descricao }}</div>
              <div>Data: {{ aulas[0].data_formatada }}</div>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>

      <v-alert v-if="aulas[0].esta_no_futuro" type="warning" border="left">
        Esta frequência só poderá ser lançada na mesma data, ou superior em que a aula foi criada
      </v-alert>

      <v-card class="mb-4">
        <v-card-title class="py-2">
          <v-icon class="mr-2">palette</v-icon>
          Legenda
        </v-card-title>
        <v-card-text class="py-2">
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center mb-2">
                <div class="color-box red lighten-4 mr-3"></div>
                <span class="text-caption">Situação adversa na matrícula</span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex align-center mb-2">
                <div class="color-box blue_light mr-3"></div>
                <span class="text-caption">Aluno com necessidades especiais (PcD)</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-row>
        <v-col cols="12">
          <v-card class="mb-5">
            <v-card-text class="pt-4">
              <v-tabs v-model="abaAtiva" color="primary" grow>
                <v-tab v-for="(aula, index) in aulas" :key="aula.id">
                  <div v-if="aula.e_aula_infantil">Lançamento de Frequência (Infantil)</div>
                  <div v-else>
                    {{ aula.horario ? aula.horario.descricao : `Horário ${index + 1}` }}
                  </div>
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="abaAtiva">
                <v-tab-item v-for="aula in aulas" :key="aula.id">
                  <div class="pa-4">
                    <div class="d-flex justify-space-between align-center mb-4">
                      <!-- <v-btn
                        color="success"
                        small
                        @click="confirmarPresencaTodos(aula.id)"
                        :disabled="aula.presencas_confirmadas"
                      >
                        <v-icon left small>mdi-check-all</v-icon>
                        Confirmar Presença para Todos
                      </v-btn>
                       -->
                      <v-chip v-if="aula.presencas_confirmadas" color="success" dark>
                        <v-icon left small>mdi-check-circle</v-icon>
                        Frequência Confirmada
                      </v-chip>
                    </div>

                    <v-simple-table dense>
                      <thead>
                        <tr>
                          <th>Aluno</th>
                          <th>Presença</th>
                          <th class="text-center">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="p in presencasPorAula[aula.id]"
                          :key="p.matricula_id"
                          :class="getRowClass(p)"
                        >
                          <td>
                            {{ p.matricula.aluno.nomecompleto }} /
                            <strong>{{ p.matricula.aluno.codigo }}</strong>
                          </td>
                          <td>
                            <v-btn-toggle :value="p.presente ? 0 : 1" mandatory dense>
                              <v-btn
                                x-small
                                :color="p.presente ? 'green' : 'grey lighten-2'"
                                :style="
                                  aula.presencas_confirmadas || aula.esta_no_futuro
                                    ? 'opacity: 0.5;'
                                    : ''
                                "
                                @click="tentarRegistrarPresenca(aula, p, true)"
                              >
                                <v-icon x-small :class="p.presente ? 'white--text' : ''"
                                  >fa fa-thumbs-up</v-icon
                                >
                              </v-btn>
                              <v-btn
                                x-small
                                :color="!p.presente ? 'red' : 'grey lighten-2'"
                                :style="
                                  aula.presencas_confirmadas || aula.esta_no_futuro
                                    ? 'opacity: 0.5;'
                                    : ''
                                "
                                @click="tentarRegistrarPresenca(aula, p, false)"
                              >
                                <v-icon x-small :class="!p.presente ? 'white--text' : ''"
                                  >fa fa-thumbs-down</v-icon
                                >
                              </v-btn>
                            </v-btn-toggle>
                          </td>
                          <td class="text-center">
                            <v-chip
                              v-if="!p.presente && p.justificativa_id"
                              x-small
                              color="green"
                              text-color="white"
                            >
                              Falta justificada
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>

                    <v-divider class="my-4"></v-divider>
                    <v-card class="elevation-2 pa-4 rounded-lg">
                      <div class="d-flex justify-space-between align-center flex-wrap">
                        <div
                          class="d-flex flex-column flex-sm-row align-start align-sm-center flex-wrap"
                        >
                          <div class="instruction-text mb-2 mb-sm-0 mr-sm-4">
                            <v-icon small class="mr-2 text--secondary"
                              >mdi-information-outline</v-icon
                            >
                            <span class="text-body-2 font-weight-medium">
                              Verifique as presenças antes de confirmar
                            </span>
                          </div>

                          <div class="legend-container d-flex align-center flex-wrap">
                            <span class="text-caption text--secondary mr-3 font-weight-medium"
                              >Legenda:</span
                            >

                            <div class="legend-item d-flex align-center mr-4">
                              <v-chip x-small color="green" text-color="white" class="mr-1 pa-3">
                                <v-icon x-small left>fa fa-thumbs-up</v-icon>
                                Presença
                              </v-chip>
                            </div>

                            <div class="legend-item d-flex align-center">
                              <v-chip x-small color="red" text-color="white" class="mr-1 pa-3">
                                <v-icon x-small left>fa fa-thumbs-down</v-icon>
                                Falta
                              </v-chip>
                            </div>
                          </div>
                        </div>

                        <div class="action-container mt-3 mt-sm-0">
                          <v-btn
                            :color="aula.presencas_confirmadas ? 'green' : 'primary'"
                            :outlined="!aula.presencas_confirmadas"
                            :depressed="aula.presencas_confirmadas"
                            elevation="0"
                            class="font-weight-medium white--text"
                            @click="abrirConfirmacao(aula)"
                            :style="aula.presencas_confirmadas ? 'pointer-events:none;' : ''"
                          >
                            <v-icon left class="mr-1">
                              {{
                                aula.presencas_confirmadas
                                  ? "mdi-check-circle"
                                  : "mdi-check-circle-outline"
                              }}
                            </v-icon>
                            <span v-if="aula.e_aula_infantil">
                              {{
                                aula.presencas_confirmadas
                                  ? "Frequência Confirmada"
                                  : "Confirmar Frequência desta Aula"
                              }}
                            </span>
                            <span v-else>
                              {{
                                aula.presencas_confirmadas
                                  ? "Frequência Confirmada"
                                  : "Confirmar Frequência deste Horário"
                              }}
                            </span>
                          </v-btn>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex justify-center">
          <v-btn color="info" dark @click="voltar">Concluir e Voltar</v-btn>
        </v-col>
      </v-row>
    </div>

    <v-alert v-else type="info" class="ma-5">
      Nenhuma aula encontrada para lançamento de frequência.
    </v-alert>

    <ModalConfirmacao
      v-if="aulaParaConfirmar"
      v-model="showConfirmacaoModal"
      titulo="Confirmar Frequência"
      acao="confirmar a frequência deste horário"
      icon="mdi-account-check"
      icon-color="primary"
      texto-confirmar="Sim, Confirmar"
      cor-botao-confirmar="success"
      icone-botao-confirmar="mdi-check-circle"
      aviso-tipo="info"
      ref="modalConfirmacao"
      @confirmado="confirmarFrequencia"
    />

    <ModalConfirmacao
      v-if="aulaInfantil"
      v-model="showAvisoSairModal"
      titulo="Atenção: Frequências Pendentes"
      acao="sair sem confirmar a frequência da aula"
      avisoTexto="As presenças não confirmadas não serão salvas como definitivas; poderão ser alteradas posteriormente através da tela de Lançamento de Frequência."
      icon="mdi-alert-circle"
      icon-color="orange"
      texto-confirmar="Sim, Sair mesmo assim"
      cor-botao-confirmar="error"
      icone-botao-confirmar="mdi-exit-to-app"
      aviso-tipo="warning"
      @confirmado="confirmarSair"
    />

    <ModalConfirmacao
      v-else
      v-model="showAvisoSairModal"
      titulo="Atenção: Frequências Pendentes"
      acao="sair sem confirmar a frequência de todos os horários selecionados"
      avisoTexto="As presenças não confirmadas não serão salvas como definitivas; poderão ser alteradas posteriormente através da tela de Lançamento de Frequência."
      icon="mdi-alert-circle"
      icon-color="orange"
      texto-confirmar="Sim, Sair mesmo assim"
      cor-botao-confirmar="error"
      icone-botao-confirmar="mdi-exit-to-app"
      aviso-tipo="warning"
      @confirmado="confirmarSair"
    />
  </main-template>
</template>

<script>
import ModalConfirmacao from "../../components/EModalConfirmacao.vue";

export default {
  components: {
    ModalConfirmacao,
  },
  props: {
    aula_ids: {
      type: String, // IDs separados por vírgula
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      submitting: false,
      aulas: [],
      abaAtiva: 0,
      presencasPorAula: {},

      showConfirmacaoModal: false,
      aulaParaConfirmar: null,

      showAvisoSairModal: false,
      leavingConfirmed: false,
      pendingRouteNext: null,

      aulaInfantil: false,
    };
  },
  async mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    await this.loadData();
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    if (!this.leavingConfirmed && this.aulas.some((a) => !a.presencas_confirmadas)) {
      this.pendingRouteNext = next;

      if (this.aulas[0].e_aula_infantil) {
        this.showAvisoSairModal = true;
        this.aulaInfantil = true;
      }

      this.showAvisoSairModal = true;
    } else {
      next();
    }
  },
  methods: {
    handleBeforeUnload(event) {
      if (this.aulas.some((a) => !a.presencas_confirmadas)) {
        event.preventDefault();
        event.returnValue = "";
      }
    },
    async loadData() {
      this.loading = true;
      try {
        const ids = this.aula_ids.split(",");

        // Usar Promise.all para buscar todas as aulas em paralelo
        const aulasCompletas = await Promise.all(
          ids.map((id) => this.$services.aulasService.getAulaComRelacoes(id))
        );

        const novasPresencas = {};

        // Usar forEach em vez de for...of
        aulasCompletas.forEach((aula) => {
          const presencas = (aula.turma?.matriculas || []).map((matricula) => {
            const falta = (aula.faltas || []).find(
              (f) => parseInt(f.matricula_id, 10) === parseInt(matricula.id, 10)
            );

            return {
              matricula,
              matricula_id: matricula.id,
              presente: !falta,
              document: falta ? falta.document : null,
              justificativa_id: falta ? falta.justificativa_id : null,
            };
          });
          novasPresencas[aula.id] = presencas;
        });

        this.aulas = aulasCompletas;
        this.presencasPorAula = novasPresencas;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.loading = false;
      }
    },
    removerEspaco(string) {
      return string.replace(" ", "_").replace(" ", "_").replace(" ", "_");
    },

    getRowClass(presenca) {
      const situacaoAdversa =
        this.$constants.situacoesMatriculaCondition[
          this.removerEspaco(presenca.matricula?.situacao ? presenca.matricula?.situacao : "")
        ];

      const especial = presenca.matricula?.aluno.especial;

      if (situacaoAdversa && especial) {
        return "red lighten-4";
      }

      if (situacaoAdversa) {
        return "red lighten-4";
      }

      if (especial) {
        return "blue_light";
      }

      return "";
    },

    mostrarAvisoConfirmado() {
      this.$toast.warn("Não é possível alterar a frequência após confirmar as presenças.");
    },

    mostrarAvisoAulaFutura() {
      this.$toast.warn(
        "Esta frequência só poderá ser lançada na mesma data, ou superior em que a aula foi criada"
      );
    },

    tentarRegistrarPresenca(aula, presenca, novoEstado) {
      if (aula.esta_no_futuro) {
        this.mostrarAvisoAulaFutura();
        return;
      }
      if (aula.presencas_confirmadas) {
        this.mostrarAvisoConfirmado();
        return;
      }
      this.registrarPresenca(aula, presenca, novoEstado);
    },

    async registrarPresenca(aula, presenca, novoEstado) {
      presenca.presente = novoEstado;
      try {
        await this.$services.aulasService.registrarPresenca(aula, presenca);
      } catch (error) {
        this.$handleError(error);
      }
    },

    async confirmarPresencaTodos(aulaId) {
      const aula = this.aulas.find((a) => a.id === aulaId);
      const presencas = this.presencasPorAula[aulaId];

      this.$loaderService.open("Confirmando presença para todos...");
      try {
        const promessas = presencas
          .filter((p) => !p.presente)
          .map((p) => {
            p.presente = true;
            return this.$services.aulasService.registrarPresenca(aula, p);
          });

        await Promise.all(promessas);
        await this.$services.aulasService.confirmarFrequencia(parseInt(aulaId, 10));
        aula.presencas_confirmadas = true;
        this.$toast.success("Frequência confirmada com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    abrirConfirmacao(aula) {
      if (aula.esta_no_futuro) {
        this.mostrarAvisoAulaFutura();
        return;
      }
      this.aulaParaConfirmar = aula;
      this.showConfirmacaoModal = true;
    },

    async confirmarFrequencia() {
      this.$refs.modalConfirmacao.setLoading(true);
      try {
        await this.$services.aulasService.confirmarFrequencia(
          parseInt(this.aulaParaConfirmar.id, 10)
        );
        this.aulaParaConfirmar.presencas_confirmadas = true;
        this.$toast.success("Frequência confirmada!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        if (this.$refs.modalConfirmacao) {
          this.$refs.modalConfirmacao.setLoading(false);
        }
        this.showConfirmacaoModal = false;
      }
    },

    voltar() {
      this.$router.push({
        name: "aulas",
        params: { gestaoDeAulaId: this.$route.params.gestaoDeAulaId },
      });
    },

    confirmarSair() {
      this.leavingConfirmed = true;
      this.showAvisoSairModal = false;
      if (this.pendingRouteNext) {
        this.pendingRouteNext();
      } else {
        this.voltar();
      }
    },
  },
};
</script>
